import classNames from "components/ui/classNames";
import { useAmplitude } from "lib/amplitude/Amplitude";
import { XIcon } from "lucide-react";
import * as React from "react";

interface NomadCashbackAdProps {
  onClose?: () => void;
}

export default function NomadCashbackAd({ onClose }: NomadCashbackAdProps) {
  const amplitude = useAmplitude();
  const couponCode = (
    <strong className="rounded-md bg-black p-0.5 px-1.5 dark:bg-[#ffd428]/20 dark:text-[#ffd428]">FUNDAMENTEI20</strong>
  );

  return (
    <div
      className={classNames(
        "relative flex w-full flex-col gap-y-6",
        "rounded-2xl p-8",
        "bg-gradient-to-l from-[#ffd500f9] to-[#030203]",
        "ring-2 ring-slate-300 ring-offset-2",
        "dark:border-2 dark:border-[#ffd428]/15 dark:bg-[#ffd428]/10 dark:bg-none dark:ring-0 dark:ring-offset-0",
      )}
    >
      <Nomad width={120} height={27} />

      <div className="flex w-full flex-col items-center gap-4 sm:flex-row">
        <p className="text-base font-medium tracking-wider text-white">
          Abra a sua conta internacional na Nomad e ganhe até US$20 de cashback com o cupom {couponCode}!
        </p>

        <a
          href="https://nomad.onelink.me/wIQT/fundamentei"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            amplitude.logEvent("Click on Nomad Download app button");
          }}
          className={classNames(
            "flex w-full cursor-pointer items-center justify-center rounded-xl p-3 text-center",
            "bg-slate-700 text-sm font-bold text-white no-underline hover:underline",
            "border border-slate-950 hover:opacity-85",
            "sm:max-w-xs",
          )}
        >
          Abrir Conta
        </a>
      </div>

      {onClose && (
        <div className="absolute right-0 top-0 -mr-2 -mt-2">
          <button
            type="button"
            className="rounded-full bg-red-600 p-1 text-white"
            aria-label="Fechar"
            onClick={() => {
              onClose?.();
              amplitude.logEvent("Closed Nomad banner");
            }}
          >
            <XIcon className="size-4" strokeWidth={3} />
          </button>
        </div>
      )}
    </div>
  );
}

function Nomad(props: React.SVGProps<any>) {
  return (
    <svg width={179} height={40} {...props} viewBox="0 0 179 40">
      <g fill="#FFD400">
        <path d="M47.344 20.698v-.076c0-7.949 6.166-14.628 14.843-14.628 8.703 0 14.767 6.577 14.767 14.527v.076c0 7.949-6.166 14.628-14.843 14.628s-14.767-6.577-14.767-14.527zm24.408 0v-.076c0-5.485-4.009-10.057-9.641-10.057-5.633 0-9.54 4.495-9.54 9.981v.076c0 5.486 4.009 10.007 9.641 10.007 5.608 0 9.54-4.445 9.54-9.93zM84.21 8.813a2.503 2.503 0 012.512-2.515h.533c1.09 0 1.826.56 2.308 1.321l8.576 13.41 8.627-13.46c.533-.839 1.268-1.296 2.258-1.296h.533a2.487 2.487 0 012.511 2.514v23.67c0 1.372-1.09 2.464-2.511 2.464a2.481 2.481 0 01-2.461-2.464v-16.94l-6.927 10.388c-.533.812-1.167 1.295-2.106 1.295-.888 0-1.522-.483-2.055-1.295l-6.876-10.311v16.914c0 1.371-1.09 2.413-2.461 2.413-1.37 0-2.436-1.042-2.436-2.413L84.21 8.813zm34.912 22.704l10.53-23.44c.557-1.245 1.572-2.007 2.993-2.007h.229c1.42 0 2.385.762 2.968 2.006l10.53 23.416c.202.356.279.737.279 1.041 0 1.321-1.015 2.388-2.335 2.388-1.167 0-1.979-.686-2.435-1.727l-2.31-5.283h-13.75l-2.386 5.46c-.406 1.016-1.268 1.575-2.309 1.575a2.286 2.286 0 01-2.309-2.311c0-.356.102-.711.305-1.118zm18.547-8l-4.973-11.428-4.973 11.428h9.946zM153.4 8.965c0-1.422 1.09-2.514 2.511-2.514h8.043C172.86 6.45 179 12.546 179 20.495v.076c0 7.95-6.165 14.146-15.046 14.146h-8.043c-1.42 0-2.511-1.092-2.511-2.514V8.965zm10.58 21.257c5.962 0 9.844-3.987 9.844-9.524v-.076c0-5.536-3.882-9.625-9.844-9.625h-5.582v19.225h5.582zM0 5.638a2.503 2.503 0 012.512-2.514h.533c1.218 0 1.826.66 2.664 1.346l29.507 24.533V5.562c0-1.32 1.091-2.438 2.436-2.438a2.443 2.443 0 012.461 2.438V33.93c0 1.372-1.065 2.464-2.435 2.464h-.203c-1.168 0-1.776-.635-2.665-1.321L4.897 10.184v23.772c0 1.32-1.091 2.412-2.436 2.412-1.37 0-2.461-1.092-2.461-2.412V5.638z" />
        <path d="M14.208 20.597c-1.37 0-2.46 1.092-2.46 2.413v14.577c0 1.32 1.09 2.413 2.46 2.413 1.345 0 2.436-1.092 2.436-2.413V23.035a2.438 2.438 0 00-2.436-2.438zm11.722 9.727c-1.37 0-2.46 1.092-2.46 2.413v4.85c0 1.32 1.09 2.413 2.46 2.413 1.345 0 2.436-1.092 2.436-2.413v-4.85c0-1.321-1.091-2.413-2.436-2.413zM25.93 0c-1.37 0-2.46 1.092-2.46 2.413v13.79c0 1.32 1.09 2.413 2.46 2.413 1.345 0 2.436-1.092 2.436-2.413V2.438A2.438 2.438 0 0025.93 0zM14.208 0c-1.37 0-2.46 1.092-2.46 2.413V6.45c0 1.32 1.09 2.412 2.46 2.412 1.345 0 2.436-1.092 2.436-2.412V2.438A2.438 2.438 0 0014.208 0z" />
      </g>
    </svg>
  );
}
